import 'bootstrap/dist/js/bootstrap.esm.js'

import './stripe_styling.js'
import '../shared/phone.js'
import '../f1/horizontal_scroll'
import '../shared/buyers_page_personalizer.js'
import '../shared/package_comparisons.js'
import '../shared/hide_map.js'
import '../shared/disable_reset.js'
import '../default/carousel_bs5.js'
import './seating_chart_filter.js'
import '../shared/no_smooth_scroll.js'
import '../shared/nav/bootstrap_nav.js'

import VueLoader from '../default/vue-loader.js'
import { store } from '../default/store/index.js'

import PriceFilter from '../shared/price_filter'
import AddToCart from '../full-gpe/cart/add-to-cart.js'
import AddToCartForms from '../shared/add_to_cart_forms/index.js'
import HotelIndex from '../shared/add_to_cart_forms/h4h_hotels/hotel_index.vue'
import CartNav from '../shared/nav/nav_cart/index.js'
import Checkout from '../shared/checkout/index.js'
import AbTests from '../shared/ab_tests.js'
import DepositRedemptions from '../shared/deposit_redemptions/index.js'

const contracted_hotel = document.getElementById('h4hHotelIndex')
const retail_hotel = document.getElementById('hotelPage')

document.addEventListener('turbo:load', () => {
  AddToCartForms.loadBottomForm()
  CartNav.addCartToNavbar()
  DepositRedemptions.findCustomerDeposits()
  Checkout.loadWithAddOn()
  AddToCart.AddToCart()

  if (contracted_hotel || retail_hotel) {
    AbTests.loadHotelAbTests()
  }

  if (document.getElementById('seating_chart_price')) {
    VueLoader.loadVueComponent(PriceFilter, document.getElementById('seating_chart_price'), store)
  }

  if (document.getElementById('hotelIndex')) {
    VueLoader.loadVueComponent(HotelIndex, document.getElementById('hotelIndex'), store)
  }
})
